/**
 * Raw motion values for consistent animation behavior.
 * Shared by CSS tokens and Motion React presets.
 */
export const MOTION_VALUES = {
	duration: {
		instant: 0,
		rapid: 0.05,
		fast: 0.15,
		normal: 0.2,
		moderate: 0.25,
		slow: 0.3,
	},
	delay: {
		none: 0,
		short: 0.1,
		medium: 0.2,
		long: 0.3,
	},
	spring: {
		gentle: { stiffness: 150, damping: 20 },
		smooth: { stiffness: 300, damping: 20 },
		snappy: { stiffness: 300, damping: 30 },
		bouncy: { stiffness: 400, damping: 25 },
		responsive: { stiffness: 400, damping: 40 },
		tight: { stiffness: 600, damping: 30 },
		crisp: { stiffness: 600, damping: 50 },
		softBounce: { stiffness: 600, damping: 15 },
	},
	scale: {
		microDown: 0.95,
		subtleDown: 0.9,
		mediumDown: 0.8,
		heavyDown: 0.5,
		default: 1,
		subtleUp: 1.05,
		mediumUp: 1.2,
	},
	opacity: {
		hidden: 0,
		skeleton: 0.3,
		disabled: 0.5,
		dragging: 0.9,
		visible: 1,
	},
} as const;
